import { useQuery } from "@tanstack/react-query";
import { getAdminUsersWithMessages } from "../api/message.api";
import { AdminUserWithMessages } from "../api/message.type";
import { qk } from "../lib/queryKeys";

export function useLoadAdminChats(enabled: boolean) {
  const {
    data: adminUsers = [],
    isLoading,
    isError,
} = useQuery<AdminUserWithMessages[]>({
  queryKey: qk.adminUsersWithMessages(),
  queryFn: getAdminUsersWithMessages,
  enabled,
  staleTime: 60_000,
});

return { adminUsers, isLoading, isError };
}
